import { Box } from '@mui/material'
import Controllers from '@/features/config/pages/Controllers/Controllers'
import type { GuidedStepComponentProps } from '../guidedSteps'

// SCRUM-1032 / SCRUM-1035 — guided-setup steps for the decoder lists.
// Embeds the refined decoder list (inline editing of purpose / name /
// configuration), scoped to the setup interface id (never the globally-selected
// interface — SCRUM-976). Controllers' `embedded` mode drops the page chrome
// (ConfigLayout sidebar offset, ConfigHeader, StatusInterface) so it sits
// directly inside the guided-setup panel.
//
// Output / Input / SDI-12 get a step each rather than tabs inside one step: the
// tab bar was a second navigation layer that was easy to walk past, leaving a
// whole decoder type unset. `fixedTab` pins the list and hides the tabs.
const decoderStep = (tab: string) => {
  const Step = ({
    interfaceId,
    focusMode,
    onToggleFocus,
  }: GuidedStepComponentProps) => (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        // Padding is viewport the grid does not get. The list is the whole
        // step, so it keeps just enough inset to not touch the wizard chrome.
        p: focusMode ? '8px 12px' : '12px 16px',
      }}
    >
      <Controllers
        interfaceId={interfaceId}
        embedded
        fixedTab={tab}
        focusMode={focusMode}
        onToggleFocus={onToggleFocus}
      />
    </Box>
  )
  return Step
}

export const OutputDecodersStep = decoderStep('0')
export const InputDecodersStep = decoderStep('1')
export const Sdi12DecodersStep = decoderStep('2')

export default OutputDecodersStep
